const FILES_LIMIT_MB = 8

export default {
    data() {
        return {
            selectedFiles: [],
            isUploading: false,
            FILES_LIMIT: FILES_LIMIT_MB * 1024 * 1024,
            ALLOWED_TYPES: ['image/png', 'image/jpg', 'image/jpeg'],
            FILES_MAX_NUMBER: 12,
        }
    },

    methods: {
        validateFiles(files, previousPhotos) {
            const newFiles = Array.from(files).map((file) => ({
                file,
                url: URL.createObjectURL(file),
                progress: 0,
                isUploaded: false,
                isUploading: true,
            }))
            const allFiles = [...this.selectedFiles, ...newFiles]

            const hasReachedLimit = allFiles.length + previousPhotos.length > this.FILES_MAX_NUMBER
            if (hasReachedLimit) {
                this.$toast.error(this.$t('components.images.multiple_image_upload.max_number', { n: this.FILES_MAX_NUMBER }))
                return hasReachedLimit
            }
            const hasWrongFileType = newFiles.some((file) => !this.ALLOWED_TYPES.includes(file.file.type))
            if (hasWrongFileType) {
                this.$toast.error(this.$t('components.images.multiple_image_upload.wrong_file_type'))
                return hasWrongFileType
            }

            const hasFilesOverLimit = newFiles.find((file) => file.file.size > this.FILES_LIMIT)
            if (hasFilesOverLimit) {
                this.$toast.error(this.$t('components.images.multiple_image_upload.files_over_limit', { n: FILES_LIMIT_MB }))
                return hasFilesOverLimit
            }

            this.selectedFiles = allFiles
        },

        convertFileToBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file.file)
                reader.onload = () =>
                    resolve({
                        ...file,
                        base64File: reader.result,
                    })
                reader.onerror = (error) => reject(error)
            })
        },
    },
}
